import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojaipurcab() {



  const cardData =
  {
    keyword: 'Mumbai to Jaipur Cab',
    heading: 'Shambhu Cabs: Mumbai to Jaipur Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Jaipur Cab services, providing safe, comfortable, and hassle-free long-distance travel for families, corporate travelers, business groups, and tourists visiting the Pink City. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Jaipur with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes intercity travel convenient, stress-free, and dependable. For comfort, safety, and a trusted Mumbai to Jaipur cab experience, Shambhu Cabs is your reliable travel partner.',

    top: 'Top Places to Visit in Jaipur with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Amer Fort",
    "description": "Amer Fort, situated on a hilltop overlooking Maota Lake, is a majestic blend of Rajput and Mughal architecture. Built with red sandstone and marble, it features ornate palaces, courtyards, and the famous Sheesh Mahal (Mirror Palace). Visitors can enjoy elephant rides, light and sound shows in the evening, and panoramic views of Jaipur. The fort represents Jaipur’s royal heritage and artistic grandeur."
  },
  {
    "title": "City Palace",
    "description": "City Palace, located in the heart of Jaipur, is a royal residence that combines Rajput, Mughal, and European architectural styles. The complex includes Chandra Mahal, Mubarak Mahal, and a museum showcasing royal costumes, weapons, and artifacts. It provides insight into the history of the Maharajas of Jaipur and offers beautiful courtyards and gardens for visitors to explore."
  },
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, known as the 'Palace of Winds', is a five-story pink sandstone structure with 953 small windows designed for royal women to observe street life without being seen. Its unique façade, intricate latticework, and airy design make it a popular photography spot. Hawa Mahal symbolizes Jaipur’s rich architectural heritage and regal lifestyle."
  },
  {
    "title": "Jantar Mantar",
    "description": "Jantar Mantar is an 18th-century astronomical observatory built by Maharaja Sawai Jai Singh II. It houses the world’s largest stone sundial and several other instruments to measure time, track stars, and predict eclipses. It is a UNESCO World Heritage Site and attracts science enthusiasts, historians, and tourists interested in ancient astronomical practices."
  },
  {
    "title": "Nahargarh Fort",
    "description": "Nahargarh Fort, perched on the Aravalli hills, offers stunning views of Jaipur city and the surrounding landscape. Built as a defense fort, it now serves as a popular sunset viewpoint. Visitors can explore the fort’s walls, terraces, and historic rooms while enjoying cafes and restaurants nearby. It combines history, architecture, and panoramic sightseeing."
  },
  {
    "title": "Jaigarh Fort",
    "description": "Jaigarh Fort, known for housing the world’s largest cannon on wheels, is a massive hilltop fortification overlooking Amer Fort and the surrounding valleys. It features robust battlements, watchtowers, and underground passages. The fort gives insights into Jaipur’s military history and provides spectacular views of the Aravalli ranges."
  },
  {
    "title": "Albert Hall Museum",
    "description": "Albert Hall Museum, located in Ram Niwas Garden, is the oldest museum in Rajasthan, showcasing Indo-Saracenic architecture. The museum houses paintings, decorative arts, sculptures, and ancient artifacts. Its beautifully illuminated façade at night makes it a visual delight, while the museum provides an educational and cultural experience for visitors."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir, a white marble temple dedicated to Lord Vishnu and Goddess Lakshmi, is located on a hilltop in Jaipur. The temple’s modern architectural design, serene atmosphere, and evening lighting attract devotees and tourists alike. It offers panoramic city views and is a peaceful spiritual retreat in the bustling city."
  },
  {
    "title": "Galtaji Temple",
    "description": "Galtaji, also known as the Monkey Temple, is an ancient Hindu pilgrimage site featuring natural springs, sacred kunds, and temples dedicated to Lord Hanuman and other deities. The temple complex is surrounded by hills and hosts a large population of monkeys. It is a serene place for spiritual visits, photography, and nature walks."
  },
  {
    "title": "Chokhi Dhani",
    "description": "Chokhi Dhani is a cultural village resort that showcases Rajasthani heritage, cuisine, folk music, dance, and traditional crafts. Visitors can enjoy camel rides, ethnic performances, and authentic meals, experiencing the vibrant culture of Rajasthan in a lively and entertaining environment."
  }
],




"services": [
  {
    "name": "Mumbai Jaipur Taxi Service",
    "description": "Reliable Mumbai Jaipur Taxi Service offering comfortable travel from Mumbai to Jaipur for all types of travelers."
  },
  {
    "name": "Jaipur from Mumbai Cab",
    "description": "Jaipur from Mumbai Cab provides safe and convenient transportation for long-distance travel."
  },
  {
    "name": "One Way Cab Mumbai Jaipur",
    "description": "One Way Cab Mumbai Jaipur is ideal for travelers needing a single-direction journey at affordable fares."
  },
  {
    "name": "Affordable Taxi Mumbai Jaipur",
    "description": "Affordable Taxi Mumbai Jaipur ensures budget-friendly travel without compromising on safety or comfort."
  },
  {
    "name": "SUV Cab Mumbai Jaipur",
    "description": "SUV Cab Mumbai Jaipur offers spacious rides for families or groups traveling to Jaipur."
  },
  {
    "name": "Sedan Cab Mumbai Jaipur",
    "description": "Sedan Cab Mumbai Jaipur provides a comfortable and economical option for solo travelers or small groups."
  },
  {
    "name": "24x7 Cab Mumbai Jaipur",
    "description": "24x7 Cab Mumbai Jaipur ensures round-the-clock taxi availability for early morning or late-night departures."
  },
  {
    "name": "Long Distance Cab Mumbai Jaipur",
    "description": "Long Distance Cab Mumbai Jaipur provides efficient travel with optimized routes for intercity journeys."
  },
  {
    "name": "Premium Taxi Mumbai Jaipur",
    "description": "Premium Taxi Mumbai Jaipur offers luxury vehicles for a stylish and comfortable ride."
  },
  {
    "name": "Fastest Cab Mumbai Jaipur",
    "description": "Fastest Cab Mumbai Jaipur guarantees timely travel with experienced drivers and optimized routes."
  },
  {
    "name": "Corporate Cab Mumbai Jaipur",
    "description": "Corporate Cab Mumbai Jaipur caters to business travelers seeking punctual and professional transport."
  },
  {
    "name": "Family Cab Mumbai Jaipur",
    "description": "Family Cab Mumbai Jaipur ensures spacious and comfortable travel for family trips to Jaipur."
  },
  {
    "name": "AC Taxi Mumbai Jaipur",
    "description": "AC Taxi Mumbai Jaipur ensures a cool and comfortable journey, perfect for all seasons."
  },
  {
    "name": "Safe Cab Mumbai Jaipur",
    "description": "Safe Cab Mumbai Jaipur prioritizes passenger safety with well-maintained vehicles and trained drivers."
  },
  {
    "name": "Best Outstation Cab Mumbai Jaipur",
    "description": "Best Outstation Cab Mumbai Jaipur provides top-rated services with professional drivers and reliable vehicles."
  }
],

"tableData": [
  ["Mumbai Jaipur Taxi Service", "Jaipur from Mumbai Cab"],
  ["One Way Cab Mumbai Jaipur", "Affordable Taxi Mumbai Jaipur"],
  ["SUV Cab Mumbai Jaipur", "Sedan Cab Mumbai Jaipur"],
  ["24x7 Cab Mumbai Jaipur", "Long Distance Cab Mumbai Jaipur"],
  ["Premium Taxi Mumbai Jaipur", "Fastest Cab Mumbai Jaipur"],
  ["Corporate Cab Mumbai Jaipur", "Family Cab Mumbai Jaipur"],
  ["AC Taxi Mumbai Jaipur", "Safe Cab Mumbai Jaipur"],
  ["Best Outstation Cab Mumbai Jaipur", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Jaipur Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to Jaipur cab services, ideal for long-distance travel, business trips, family journeys, and comfortable interstate rides."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and comfortable journey from Mumbai to Jaipur."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our skilled drivers are well-acquainted with the Mumbai to Jaipur route, ensuring safe driving, timely arrivals, and a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Mumbai to Jaipur cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route guidance, and any travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans to suit your Mumbai to Jaipur journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Jaipur journey smooth, comfortable, and stress-free."
  }
]

































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Jaipur?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Jaipur, ensuring a smooth and enjoyable journey to the Pink City.',
  },
  {
    question: 'How can I book a cab from Mumbai to Jaipur?',
    answer: 'You can easily book a cab from Mumbai to Jaipur via our website, mobile app, or by contacting our 24x7 customer support team for a seamless and convenient booking experience.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Jaipur cab bookings?',
    answer: 'Shambhu Cabs offers a variety of vehicles for your Mumbai to Jaipur journey, including sedans, SUVs, luxury cars, and Tempo Travellers for group trips or family travel.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Jaipur journey?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the route to Jaipur, ensuring a safe, comfortable, and timely journey.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Jaipur trip?',
    answer: 'Yes, you can select your preferred pickup and drop-off locations in Mumbai and Jaipur for a more flexible and personalized travel experience.',
  },
  {
    question: 'Is the Mumbai to Jaipur cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs provides 24x7 service for your journey from Mumbai to Jaipur, allowing you to travel at a time that fits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Jaipur trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene measures to ensure your well-being during the trip.',
  },
  {
    question: 'What payment options are available for Mumbai to Jaipur cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all Mumbai to Jaipur cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai to Jaipur trip?',
    answer: 'Yes, Shambhu Cabs offers 24x7 customer support to assist you throughout your journey from Mumbai to Jaipur.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arun Mehta',
    feedback: 'The trip from Mumbai to Jaipur with Shambhu Cabs was fantastic! The driver was friendly, the car was in excellent condition, and we had a comfortable and enjoyable journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rupal Sharma',
    feedback: 'I traveled from Mumbai to Jaipur with Shambhu Cabs, and it was a pleasant experience. The car was spacious, the driver was punctual, and the overall service was top-notch.',
    rating: 5,
  },
];

















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const mumbaiJaipurCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Jaipur Cab",
  "serviceType": "Outstation Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-jaipur-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Jaipur cab services. Book affordable, SUV, sedan, and premium cabs for one-way, long distance, corporate, or family travel, available 24×7.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "820",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-jaipur-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Jaipur, India" }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Jaipur Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Jaipur cab services with Shambhu Cabs. Affordable SUV, sedan, and premium cabs for one-way, long distance, corporate, or family travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Jaipur Taxi Service, Jaipur from Mumbai Cab, One Way Cab Mumbai Jaipur, Affordable Taxi Mumbai Jaipur, SUV Cab Mumbai Jaipur, Sedan Cab Mumbai Jaipur, 24x7 Cab Mumbai Jaipur, Long Distance Cab Mumbai Jaipur, Premium Taxi Mumbai Jaipur, Fastest Cab Mumbai Jaipur, Corporate Cab Mumbai Jaipur, Family Cab Mumbai Jaipur, AC Taxi Mumbai Jaipur, Safe Cab Mumbai Jaipur, Best Outstation Cab Mumbai Jaipur"
  />

  <script type="application/ld+json">
    {JSON.stringify(mumbaiJaipurCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojaipurcab;